jQuery(function() {
    jQuery('#regionmap').html('');
    vStateData = [];
    regionPalette = {};
    var stateColors = {
        "AK": "#50944b",
        "CA": "#50944b",
        "ID": "#50944b",
        "OR": "#50944b",
        "WA": "#50944b",
        "NV": "#50944b",
        "AZ": "#50944b",
        "FL": "#323a8c",
        "DC": "#E63E58",
        "RI": "#00ACEC",
        "MA": "#00ACEC",
        "VT": "#00ACEC",
        "ME": "#00ACEC",
        "GA": "#323A8C",
        "NC": "#323A8C",
        "MS": "#323A8C",
        "TN": "#323A8C",
        "SC": "#323A8C",
        "AL": "#323A8C",
        "NY": "#00ACEC",
        "NJ": "#00ACEC",
        "DE": "#E63E58",
        "HI": "#50944B",
        "MD": "#E63E58",
        "VA": "#E63E58",
        "PA": "#E63E58",
        "KY": "#323A8C",
        "NH": "#00ACEC",
        "CT": "#00ACEC",
        "PR": "#00ACEC",
        "VI": "#00ACEC",
        "GU": "#50944B",
        "WV": "#E63E58",
        "MT": "#FF7F00",
        "WY": "#FF7F00",
        "UT": "#FF7F00",
        "NM": "#FF7F00",
        "TX": "#FF7F00",
        "OK": "#FF7F00",
        "SD": "#FF7F00",
        "ND": "#FF7F00",
        "CO": "#FF7F00",
        "LA": "#FF7F00",
        "AR": "#FF7F00"
    };
    map = renderColorMap(stateColors);
});

jQuery(function() {
  jQuery("#whdmap").html("");
  vStateData = [];
  regionPalette = {};
  map = renderWhdMap();  
});

jQuery(function() {
  jQuery("#minwagemap").html("");
  vStateData = [
    { "State": "AK", "Wage": "$9.89", "Type": "States with Higher Minimum Wage than Federal", "FootNote": "Y" },
    { "State": "AR", "Wage": "$9.25", "Type": "States with Higher Minimum Wage than Federal", "FootNote": "Y" },
    { "State": "AZ", "Wage": "$11.00", "Type": "States with Higher Minimum Wage than Federal", "FootNote": "" },
    { "State": "CA", "Wage": "$11.00", "Type": "States with Higher Minimum Wage than Federal", "FootNote": "Y" },
    { "State": "CO", "Wage": "$11.10", "Type": "States with Higher Minimum Wage than Federal", "FootNote": "Y" },
    { "State": "CT", "Wage": "$10.10", "Type": "States with Higher Minimum Wage than Federal", "FootNote": "Y" },
    { "State": "DC", "Wage": "$14.00", "Type": "States with Higher Minimum Wage than Federal", "FootNote": "Y" },
    { "State": "DE", "Wage": "$8.75", "Type": "States with Higher Minimum Wage than Federal", "FootNote": "" },
    { "State": "FL", "Wage": "$8.46", "Type": "States with Higher Minimum Wage than Federal", "FootNote": "" },
    { "State": "HI", "Wage": "$10.10", "Type": "States with Higher Minimum Wage than Federal", "FootNote": "Y" },
    { "State": "IL", "Wage": "$8.25", "Type": "States with Higher Minimum Wage than Federal", "FootNote": "Y" },
    { "State": "MA", "Wage": "$12.00", "Type": "States with Higher Minimum Wage than Federal", "FootNote": "Y" },
    { "State": "MD", "Wage": "$10.10", "Type": "States with Higher Minimum Wage than Federal", "FootNote": "Y" },
    { "State": "ME", "Wage": "$11.00", "Type": "States with Higher Minimum Wage than Federal", "FootNote": "Y" },
    { "State": "MI", "Wage": "$9.45", "Type": "States with Higher Minimum Wage than Federal", "FootNote": "Y" },
    { "State": "MN", "Wage": "$9.86", "Type": "States with Higher Minimum Wage than Federal", "FootNote": "Y" },
    { "State": "MO", "Wage": "$8.60", "Type": "States with Higher Minimum Wage than Federal", "FootNote": "Y" },
    { "State": "MT", "Wage": "$8.50", "Type": "States with Higher Minimum Wage than Federal", "FootNote": "Y" },
    { "State": "NE", "Wage": "$9.00", "Type": "States with Higher Minimum Wage than Federal", "FootNote": "" },
    { "State": "NJ", "Wage": "$10.00", "Type": "States with Higher Minimum Wage than Federal", "FootNote": "Y" },
    { "State": "NM", "Wage": "$7.50", "Type": "States with Higher Minimum Wage than Federal", "FootNote": "Y" },
    { "State": "NY", "Wage": "$11.10", "Type": "States with Higher Minimum Wage than Federal", "FootNote": "Y" },
    { "State": "NV", "Wage": "$8.25", "Type": "States with Higher Minimum Wage than Federal", "FootNote": "Y" },
    { "State": "OH", "Wage": "$8.55", "Type": "States with Higher Minimum Wage than Federal", "FootNote": "Y" },
    { "State": "OR", "Wage": "$11.25", "Type": "States with Higher Minimum Wage than Federal", "FootNote": "Y" },
    { "State": "RI", "Wage": "$10.50", "Type": "States with Higher Minimum Wage than Federal", "FootNote": "Y" },
    { "State": "SD", "Wage": "$9.10", "Type": "States with Higher Minimum Wage than Federal", "FootNote": "" },
    { "State": "VT", "Wage": "$10.78", "Type": "States with Higher Minimum Wage than Federal", "FootNote": "Y" },
    { "State": "WA", "Wage": "$12.00", "Type": "States with Higher Minimum Wage than Federal", "FootNote": "Y" },
    { "State": "WV", "Wage": "$8.75", "Type": "States with Higher Minimum Wage than Federal", "FootNote": "Y" },
    { "State": "IA", "Wage": "$7.25", "Type": "States with the same Minimum Wage as Federal", "FootNote": "" },
    { "State": "ID", "Wage": "$7.25", "Type": "States with the same Minimum Wage as Federal", "FootNote": "Y" },
    { "State": "GU", "Wage": "$8.25", "Type": "States with the same Minimum Wage as Federal", "FootNote": "Y" },
    { "State": "VI", "Wage": "$10.50", "Type": "States with the same Minimum Wage as Federal", "FootNote": "Y" },
    { "State": "PR", "Wage": "$7.25", "Type": "States with the same Minimum Wage as Federal", "FootNote": "Y" },
    { "State": "IN", "Wage": "$7.25", "Type": "States with the same Minimum Wage as Federal", "FootNote": "Y" },
    { "State": "KS", "Wage": "$7.25", "Type": "States with the same Minimum Wage as Federal", "FootNote": "" },
    { "State": "KY", "Wage": "$7.25", "Type": "States with the same Minimum Wage as Federal", "FootNote": "Y" },
    { "State": "NC", "Wage": "$7.25", "Type": "States with the same Minimum Wage as Federal", "FootNote": "Y" },
    { "State": "ND", "Wage": "$7.25", "Type": "States with the same Minimum Wage as Federal", "FootNote": "Y" },
    { "State": "NH", "Wage": "$7.25", "Type": "States with the same Minimum Wage as Federal", "FootNote": "Y" },
    { "State": "OK", "Wage": "$7.25", "Type": "States with the same Minimum Wage as Federal", "FootNote": "" },
    { "State": "PA", "Wage": "$7.25", "Type": "States with the same Minimum Wage as Federal", "FootNote": "Y" },
    { "State": "TX", "Wage": "$7.25", "Type": "States with the same Minimum Wage as Federal", "FootNote": "" },
    { "State": "UT", "Wage": "$7.25", "Type": "States with the same Minimum Wage as Federal", "FootNote": "" },
    { "State": "VA", "Wage": "$7.25", "Type": "States with the same Minimum Wage as Federal", "FootNote": "" },
    { "State": "WI", "Wage": "$7.25", "Type": "States with the same Minimum Wage as Federal", "FootNote": "Y" },
    { "State": "GA", "Wage": "$7.25", "Type": "States with the same Minimum Wage as Federal", "FootNote": "" },
    { "State": "WY", "Wage": "$7.25", "Type": "States with the same Minimum Wage as Federal", "FootNote": "" },
    { "State": "AL", "Wage": "", "Type": "States with no Mimimum Wage rates - Federal Applies", "FootNote": "" },
    { "State": "LA", "Wage": "", "Type": "States with no Mimimum Wage rates - Federal Applies", "FootNote": "" },
    { "State": "MS", "Wage": "", "Type": "States with no Mimimum Wage rates - Federal Applies", "FootNote": "" },
    { "State": "SC", "Wage": "", "Type": "States with no Mimimum Wage rates - Federal Applies", "FootNote": "" },
    { "State": "TN", "Wage": "", "Type": "States with no Mimimum Wage rates - Federal Applies", "FootNote": "" },
    { "State": "AS", "Wage": "", "Type": "States with special Minimum Wage", "FootNote": "" },
    { "State": "CNMI", "Wage": "$7.05", "Type": "States with lower Mimimum Wage rates - Federal Applies", "FootNote": "" }
  ];
  map = renderMinwageMap(vStateData);
});

